import React, { useState, useEffect, useContext, useRef } from 'react'
import Wrapper from '../../../../components/common/Wrapper/Wrapper'
import organisms from '../../../../components/organisms'
import { useToasts } from 'react-toast-notifications';
import service from '../../../../api/services'
import { HeaderHeading } from '../../../../Context'
import { BarcodeDataProps, ErrorsProps, SkuOptionsProps } from './interface';
import { getDropdown } from '../../../../constants/utils';
import { validationRules } from './validation';

const { InventoryAudit } = organisms


const Index = () => {
    const [barcodeData, setBarcodeData] = useState<BarcodeDataProps | null>(null)
    const { setHeader, setSidebar }: any = useContext(HeaderHeading);
    const [skuOptions, setSkuOptions] = useState<SkuOptionsProps>()
    const [updateData, setUpdateData] = useState<any>({
        item_condition: null,
        conditionRemark: "",
    })
    const [errors, setErrors] = useState<ErrorsProps | null>(null)
    const { addToast } = useToasts();
    const searchTabContainer = useRef<HTMLDivElement>(null);

    const getSkuList = async (id: string) => {
        try {
            const response = await service.sku.list(id)
            if (response.status === 200) {
                setSkuOptions(getDropdown(response?.data?.data, "sku_number"))
            }
        } catch (error: any) {
            console.log('error', error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });

        }
    }

    const handleBarcodeSearch = async (search: string) => {
        try {
            const response = await service.InventoryAuditService.barcodeSearchApi({ search: search })
            if (response.status === 200) {
                getSkuList(response?.data?.data?.store?.id)
                setBarcodeData(response?.data?.data)
                setUpdateData({ ...updateData, item_condition: null, conditionRemark: "" })
            }
        } catch (error: any) {
            console.log('error', error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });

        }
    }

    const updateItemCondition = async (id: string) => {
        const payload = {
            "item_condition": updateData.item_condition.value,
            "condition_remark": updateData.conditionRemark,
            "sku_id": updateData.sku.value
        }
        try {
            const response = await service.InventoryAuditService.updateItemCondition(id, payload)
            if (response.status === 200) {
                // handleBarcodeSearch(searchValue)
                setBarcodeData(null)
                addToast(response?.data?.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
                if (searchTabContainer?.current) {
                    const inputElement = searchTabContainer.current.querySelector('input');
                    if (inputElement) {
                        (inputElement as HTMLInputElement).value = '';
                    }
                }
            }
        } catch (error: any) {
            console.log('error', error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    const handleChange = (name: string, value: any) => {
        setUpdateData({ ...updateData, [name]: value })
    }

    // for validation for inventory audit
    const validate = () => {
        let newErrors: any = {};
        const rules: any = validationRules
        for (const field in rules) {
            if (rules.hasOwnProperty(field)) {
                if (rules[field]?.required && (!updateData[field] || updateData[field]?.length === 0)) {
                    newErrors[field] = "This field is required.";
                }
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // end

    const handleSubmit = (id: string) => {
        const isValid = validate();
        if (isValid) {
            updateItemCondition(id)
        }
    }

    useEffect(() => {
        setHeader("Inventory - Inventory Audit")
        setSidebar(false)
    }, [])

    return (
        <Wrapper>
            <InventoryAudit
                handleBarcodeSearch={(search: string) => handleBarcodeSearch(search)}
                updateItemCondition={(id:string)=>handleSubmit(id)}
                barcodeData={barcodeData}
                handleChange={handleChange}
                updateData={updateData}
                searchTabContainer={searchTabContainer}
                skuOptions={skuOptions}
                errors={errors}
            />
        </Wrapper>
    )
}

export default Index